export default "__VITE_ASSET__829461fd__"